import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import classNames from 'classnames';
import './histogram.style.scss';

export const Histogram = ({
  clickableFilters,
  onClick,
  onFilterChange,
  percentage,
  ratings,
  totalReviews,
}) => {

  const getPercentageRating = (countOfStarReviews) => {
    return (parseInt(countOfStarReviews, 10) / parseInt(totalReviews, 10)) * 100;
  };

  const histogramBarClick = (ratingValue, count) => {
    if (clickableFilters && count > 0) {
      if (onFilterChange) {
        onFilterChange(ratingValue);
      }
      if (onClick) {
        onClick(ratingValue);
      }
    }
  };

  return (
    <div className="reviews-histogram">
      {ratings
        .sort((i, n) => n.ratingValue - i.ratingValue)
        .map((histogram) => {
          const { count, ratingValue } = histogram;
          const percentageRating = getPercentageRating(count);
          const histogramWrapperClass = classNames('reviews-histogram__bar-wrapper', {
            'reviews-histogram__bar-wrapper--underline': clickableFilters && count !== 0,
          });
          const countClass = classNames('reviews-histogram__bar-count', {
            'reviews-histogram__bar-count-clickable': clickableFilters && count !== 0,
          });
          const btnWrapperClass = classNames('reviews-histogram__bar-graph', {
            pointer: clickableFilters && count !== 0,
          });
          return (
            <div
              key={ratingValue}
              role="presentation"
              className={histogramWrapperClass}
              onClick={() => {
                histogramBarClick(parseInt(ratingValue, 10), count);
              }}
            >
              <span className="reviews-histogram__bar-rating">{ratingValue}</span>
              <Image
                alt="star-icon"
                className="reviews-histogram__bar-stars"
                height="32"
                src="https://assets.thdstatic.com/images/v1/star-symbol--orange.svg"
                width="32"
              />
              <button className={btnWrapperClass} type="button">
                <span
                  className="reviews-histogram__bar-graph--percent"
                  style={{ width: `${percentageRating}%` }}
                />
              </button>
              <span className={countClass}>
                {percentage ? `${parseInt(percentageRating, 10)}%` : `${count}`}
              </span>
            </div>
          );
        })}
    </div>
  );
};

Histogram.propTypes = {
  clickableFilters: PropTypes.bool,
  /** Function when bar is clicked */
  onClick: PropTypes.func,
  onFilterChange: PropTypes.func,
  /** display percentage value instead of count */
  percentage: PropTypes.bool,
  /** Histogram bar label and number of star ratings to calculate % */
  ratings: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      ratingValue: PropTypes.number,
    })
  ),
  /** Number of total reviews */
  totalReviews: PropTypes.number.isRequired,
};

Histogram.defaultProps = {
  clickableFilters: false,
  onClick: null,
  onFilterChange: null,
  percentage: false,
  ratings: [],
};
